<template>
    <div v-if="result" class="useful-information-card">
      <div class="useful-information-card__picture">
        <img
          class="useful-information-card__image"
          :src="result?.image"
          alt="useful-information"
        >
      </div>
      <div class="useful-information-labels">
        <span class="useful-information-labels__item">
          {{ result.date }}
        </span>
        <span class="useful-information-labels__item">
          {{ result.readTime }}
        </span>
      </div>
      <a
        class="useful-information-card__title"
        :href="result.url"
      >
        {{ result.title }}
      </a>
      <p class="useful-information-card__text">
        {{ result.text }}
      </p>
    </div>
</template>

<script>
export default {
    name: 'UsefulInformationCard',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.useful-information-card{
  &__picture{
    display: flex;
    justify-content: center;
  }
  &__image{
    border-radius: 6px;
    margin-bottom: 26px;
    max-height: 121px;
    @include tablet{
      max-height: 112px;
    }
    @include desktop{
      max-height: 217px;
    }
  }
  &__title{
    display: block;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    color: #000000;
    margin-bottom: 30px;
    @include tablet{
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 18px;
    }
  }
  &__text{
    font-size: 16px;
    line-height: 26px;
    color: #252425;
    margin-bottom: 0;
    @include tablet{
      font-size: 14px;
      line-height: 20px;
    }
  }
}
.useful-information-labels{
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 20px;
  color: #161515;
  margin-bottom: 11px;
  @include tablet{
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 15px;
  }
  &__item{
    border: 1px solid #EBEBEB;
    border-radius: 6px;
    padding: 6px 9px;
    &:not(:last-child) {
      margin-right: 5px;
    }
  }
}
</style>